(function(jQuery)
{
	jQuery.framework = jQuery.framework || {};
	
	jQuery.framework.interchange = function()
	{
		
	}
})(jQuery);

jQuery(document).ready(function()
{
	jQuery("img[data-t21interchange]").each(function()
	{
		alert("do something");
	});
});
